import React from "react";
import "../stylesheet/prescription.css";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { BiSolidPlusCircle } from "react-icons/bi";
import { FiEye } from "react-icons/fi";
import InventoryCards from "../components/billings/InventoryCards";
import InventoryActivities from "../components/inventory/InventoryActivities";
import activitiesData from "../components/billings/BillingActivities";
import Topnav from "../components/others/Topnav";
import {
  getAllInventory,
  saveSelectedInventory,
  deleteInventory,
} from "../Utils/localStore";
const Inventory = () => {
  const [showActivities, setShowActivities] = useState(true);

  const handleButtonClick = () => {
    setShowActivities(!showActivities);
  };

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="prescription_body">
      <Topnav />
      <div className="prescription">
        <div ref={dropdownRef} className="drop">
          <div className="flex justify-end w-full">
            <button onClick={toggleDropdown}>
              Inventory manager
              <span>{isOpen ? "▲" : "▼"}</span>
            </button>
            {isOpen && (
              <div className="top-button_dropdown w-[231px] bg-white z-10 absolute rounded-md border-gray-400/20 border-[2px] py-2">
                <div className="p-3 hover:bg-slate-200 cursor-pointer">
                <Link to="/inventory/new_inventory">
                  <div className="flex justify-center items-center">
                    <BiSolidPlusCircle />
                    <p className="ml-2">Add new inventory </p>
                  </div>
                </Link>
                </div>

                <div className="p-3 hover:bg-slate-200 cursor-pointer">
                <Link to="/inventory/all_inventories">
                  <div className="flex justify-center items-center">
                    <FiEye />
                    <p className="ml-2">View all inventories </p>
                  </div>
                </Link>
                </div>
              </div>
            )}
          </div>
        </div>

        <InventoryCards />

        <div className="view_button">
          <button onClick={handleButtonClick}>View custom report</button>
        </div>

        <div className="recent">
          <InventoryActivities data={activitiesData} />
        </div>
      </div>
    </div>
  );
};

export default Inventory;
